import React, { useState, useEffect } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  Select,
  MenuItem,
  IconButton
} from '@mui/material';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import SearchIcon from '@mui/icons-material/Search';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import CloseIcon from '@mui/icons-material/Close';
import './Recipient.scss';
import { AiOutlineSearch } from 'react-icons/ai';
import CheerioButton from '../../../Components/CheerioButton';
import colors from '../../../Utils/colors';
import { getRecipientsList, downloadSequenceLabelData } from '../../../Services';
import { useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import images from '../../../Utils/images';
import { gettime } from '../../../Utils/localdate';
import { toast } from 'react-toastify';
import { MailRepliesModal } from '../../WhatsAppReplies/components/MailRepliesModal';
import SpinnerLoader from '../../../Components/SpinnerLoader';
import './Recipient.scss';

const Recipients = () => {
  const { labelId, labelName } = useParams();
  const authToken = useSelector((state) => state.main.auth_token);
  const navigate = useNavigate();
  const localdata = useSelector((state) => state.main.localdata);

  const [recipientsData, setRecipientsData] = useState([]);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [searchQuery, setSearchQuery] = useState('');
  const [totalDocs, setTotalDocs] = useState(0);
  const [loading, setLoading] = useState(false);
  const [mailFormData, setMailFormData] = useState(false);
  const [email, setEmail] = useState(localdata?.email);

  const columns = [
    { id: 'name', label: 'Name', minWidth: 150 },
    { id: 'email', label: 'Email Id', minWidth: 200 },
    { id: 'createdAt', label: 'Created On', minWidth: 150 },
    { id: 'verification', label: 'Verification', minWidth: 150 },
    { id: 'verificationDate', label: 'LastVerificationCheck Date', minWidth: 150 }
  ];

  const fetchgetRecipientsListApiCall = (search = '') => {
    setLoading(true);
    const data = { labelId };
    const token = authToken;
    const currentPage = page;
    const limit = rowsPerPage;

    getRecipientsList(data, token, currentPage, limit, search)
      .then((res) => {
        if (res?.flag) {
          setRecipientsData(res?.data?.docs);
          setTotalDocs(res?.data?.totalDocs);
        } else {
          setRecipientsData([]);
          setTotalDocs(0);
        }
        setLoading(false);
      })
      .catch(error => {
        console.error("Error fetching recipients:", error);
        setRecipientsData([]);
        setTotalDocs(0);
        setLoading(false);
      });
  };

  const downloadCsvApiCall = () => {
    let token = authToken;
    let data = {
      labelId: labelId,
      email: localdata?.email,
    };
    downloadSequenceLabelData(data, token).then((res) => {
      if (res?.flag) {
        toast.success("CSV sent to your email id", {
          autoClose: true,
          position: 'top-right',
        });
      } else {
        toast.error('CSV download failed, please try again later', {
          autoClose: true,
          position: 'top-right',
        });
      }
    });
  };

  const determineVerificationStatus = (doc) => {
    if (!doc.verificationData?.isValidSyntax) return 'Invalid';
    if (doc.verificationData?.isSafeToSend) return 'Verified';
    if (doc.verificationData?.isDisposable) return 'Disposable';
    return 'Unverified';
  };

  const processedData = recipientsData?.map(doc => ({
    name: doc.name,
    email: doc.email,
    createdAt: gettime(doc.createdAt),
    verification: doc.verificationData ? determineVerificationStatus(doc) : 'Verification is not yet done',
    verificationDate: doc.verificationData?.lastVerficationCheck
      ? gettime(doc.verificationData.lastVerficationCheck)
      : 'Verification is not yet done'
  }));

  const getVerificationColor = (status) => {
    switch (status) {
      case 'Verified': return '#4CAF50';
      case 'Invalid': return '#F44336';
      case 'Disposable': return '#FF9800';
      default: return '#757575';
    }
  };

  const handleChangePage = (newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(1);
  };

  const unverifiedCount = processedData?.filter(item => item.verification === 'Unverified').length;


  useEffect(() => {
    fetchgetRecipientsListApiCall(searchQuery);
  }, [searchQuery, page, rowsPerPage]);

  return (
    <div className="recipients-container" style={{ width: '100%', backgroundColor: '#fff', minHeight: '100vh' }}>
      <div style={{
        padding: '16px 24px',
        borderBottom: '1px solid #E0E0E0',
        backgroundColor: '#FFFFFF',
        width: '100%',
        display: 'flex',
        alignItems: 'center'
      }}>
        <img
          src={images.BackArrowBlack}
          style={{ height: 24, width: 24, objectFit: 'contain', cursor: 'pointer', marginInlineEnd: 16 }}
          onClick={() => {
            navigate(-1)
          }}
        />
        <div className="d-flex flex-row justify-content-between align-items-center w-100">

          <h3 style={{ fontSize: 20, fontWeight: 700 }}>
            {labelName || 'Label Name'}
          </h3>
        </div>

        <div className="search_container" style={{ width: '36%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div className="search_upload_row" style={{ display: 'flex', alignItems: 'center' }}>
            <div className="logged_input" style={{ display: 'flex', alignItems: 'center' }}>
              <AiOutlineSearch size={16} />
              <input
                className="search_input"
                type="text"
                placeholder="Search recipients"
                value={searchQuery}
                onChange={(e) => {
                  setPage(1)
                  setSearchQuery(e.target.value)
                }}
                style={{ marginLeft: '8px', border: 'none', outline: 'none' }}
              />
            </div>
          </div>
          <CheerioButton
            borderStyle={{
              border: `1px solid ${colors.darkPurple}`,
              paddingBlock: 6,
              paddingInline: 20,
            }}
            textStyle={{ fontSize: 16, fontWeight: 600, color: colors.white01 }}
            btnText={'Download'}
            onclick={() => {
              setMailFormData(true);
            }}
            backColor={colors.darkPurple}
          />
        </div>
      </div>
      {mailFormData && (
      <MailRepliesModal
        show={mailFormData}
        reportName={'Download Recipients List'}
        setShow={setMailFormData}
        mailApiCall={downloadCsvApiCall}
        email={email}
        setEmail={setEmail}
      ></MailRepliesModal>
    )}

      {/* {unverifiedCount > 0 && (
        <div style={{
          backgroundColor: '#ECE1FF',
          borderRadius: '8px',
          padding: '16px',
          margin: '16px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span style={{color: colors.darkPurple}}>
              Your selected label has {unverifiedCount} unverified emails. Do you want to verify?
            </span>
          </div>
          <CheerioButton
            borderStyle={{
              border: `1px solid ${colors.darkPurple}`,
              paddingBlock: 6,
              paddingInline: 20,
            }}
            textStyle={{ fontSize: 16, fontWeight: 600, color: colors.darkPurple }}
            btnText={'Verify'}
            onclick={() => {
              // Implement verify functionality
            }}
            backColor='#ECE1FF'
          />
        </div>
      )} */}

      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  style={{
                    minWidth: column.minWidth,
                    backgroundColor: '#f9f9f9',
                    fontWeight: 500
                  }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={columns.length} align="center" style={{ padding: '40px 0' }}>
                  <div className="d-flex flex-column justify-content-center align-items-center w-100" style={{ flex: 1 }}>
                    <SpinnerLoader />
                  </div>
                </TableCell>
              </TableRow>
            ) : processedData?.length === 0 ? (
              <TableRow>
                <TableCell colSpan={columns.length} align="center">
                  No recipients found
                </TableCell>
              </TableRow>
            ) : (
              processedData?.map((row, index) => (
                <TableRow key={index}>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      style={{
                        color: column.id === 'verification'
                          ? getVerificationColor(row[column.id])
                          : 'inherit',
                        fontWeight: column.id === 'verification' ? 500 : 400
                      }}
                    >
                      {row[column.id]}
                    </TableCell>
                  ))}
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <Box style={{
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        padding: '16px 8px',
        borderTop: '1px solid #e0e0e0'
      }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <span style={{ marginRight: '8px', fontSize: '14px' }}>Rows per page:</span>
          <Select
            value={rowsPerPage}
            onChange={handleChangeRowsPerPage}
            size="small"
            style={{ marginRight: '16px', height: '32px' }}
          >
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={20}>20</MenuItem>
            <MenuItem value={50}>50</MenuItem>
          </Select>
          <span style={{ fontSize: '14px', color: '#757575', marginRight: '16px' }}>
            {`${(page - 1) * rowsPerPage + 1}-${Math.min(page * rowsPerPage, totalDocs)} of ${totalDocs}`}
          </span>
          <IconButton
            size="small"
            disabled={page === 1}
            onClick={() => handleChangePage(page - 1)}
          >
            <KeyboardArrowLeftIcon fontSize="small" />
          </IconButton>
          <IconButton
            size="small"
            disabled={page * rowsPerPage >= totalDocs}
            onClick={() => handleChangePage(page + 1)}
          >
            <KeyboardArrowRightIcon fontSize="small" />
          </IconButton>
        </div>
      </Box>
    </div>
  );
};

export default Recipients;